import { render, staticRenderFns } from "./yxAI.vue?vue&type=template&id=1ea211d8"
import script from "./yxAI.vue?vue&type=script&lang=js"
export * from "./yxAI.vue?vue&type=script&lang=js"
import style0 from "./yxAI.vue?vue&type=style&index=0&id=1ea211d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports